export const COLOR_OPTIONS = [
  { value: "green", label: "Green" },
  { value: "yellow", label: "Yellow" },
  { value: "red", label: "Red" },
  { value: "blue", label: "Blue" },
  { value: "gray", label: "Neutral" },
];

const COLOR_CLASSES = {
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  red: "bg-red-100 text-red-800",
  blue: "bg-blue-100 text-blue-800",
  gray: "bg-gray-100 text-gray-700",
};

export const supportsColorRules = (fieldType) =>
  ["yes_no", "positive_integer", "duration", "time", "select"].includes(
    fieldType
  );

export const defaultColorRules = (fieldType, options = []) => {
  if (fieldType === "yes_no") {
    return { enabled: true, yesColor: "green", noColor: "red" };
  }
  if (fieldType === "select") {
    return {
      enabled: false,
      optionColors: Object.fromEntries(
        options.map((option) => [String(option.value), "blue"])
      ),
    };
  }
  if (["positive_integer", "duration", "time"].includes(fieldType)) {
    return {
      enabled: false,
      direction: fieldType === "time" ? "lower" : "higher",
      greenThreshold: fieldType === "time" ? "06:00" : 0,
      yellowThreshold: fieldType === "time" ? "06:30" : 0,
    };
  }
  return { enabled: false };
};

const parseTimeToMinutes = (value) => {
  if (typeof value !== "string" || !value.includes(":")) return NaN;
  const [hours, minutes] = value.split(":").map(Number);
  return hours * 60 + minutes;
};

const comparableValue = (value, fieldType) => {
  if (fieldType === "time") return parseTimeToMinutes(String(value));
  if (fieldType === "duration" && typeof value === "string" && value.includes(":")) {
    return parseTimeToMinutes(value);
  }
  return Number(value);
};

export const colorClassForFieldValue = (field, value) => {
  if (value === undefined || value === null || value === "") {
    return COLOR_CLASSES.gray;
  }

  if (!supportsColorRules(field?.field_type)) return COLOR_CLASSES.gray;

  const rules = field?.color_rules || defaultColorRules(
    field?.field_type,
    field?.options
  );
  if (!rules.enabled) return COLOR_CLASSES.blue;

  let color = "blue";
  if (field.field_type === "yes_no") {
    color = Boolean(value) ? rules.yesColor : rules.noColor;
  } else if (field.field_type === "select") {
    color = rules.optionColors?.[String(value)] || "blue";
  } else if (["positive_integer", "duration", "time"].includes(field.field_type)) {
    const actual = comparableValue(value, field.field_type);
    const green = comparableValue(rules.greenThreshold, field.field_type);
    const yellow = comparableValue(rules.yellowThreshold, field.field_type);
    if (Number.isFinite(actual) && Number.isFinite(green) && Number.isFinite(yellow)) {
      if (rules.direction === "lower") {
        color = actual <= green ? "green" : actual <= yellow ? "yellow" : "red";
      } else {
        color = actual >= green ? "green" : actual >= yellow ? "yellow" : "red";
      }
    }
  }

  return COLOR_CLASSES[color] || COLOR_CLASSES.blue;
};
